import { createContext, useContext } from 'react';

type CleanupFn = () => void;

export type ItemEntry = { itemId: string; element: HTMLElement };

export type ListContextValue = {
  getListLength: () => number;
  registerItem: (entry: ItemEntry) => CleanupFn;
  instanceId: symbol;
};

export const ListContext = createContext<ListContextValue | null>(null);

export function useListContext() {
  const listContext = useContext(ListContext);
  if (!listContext) {
    throw new Error('listContext is null');
  }
  return listContext;
}
